import {merge} from 'merge-json'

export const DefaultOptions = {
  tabWidth: 2,
  useTabs: false
}

export default async function mergeJSON(input1, input2, options) {
  const {tabWidth, useTabs} = {...DefaultOptions, ...options}

  const object1 = JSON.parse(input1)
  const object2 = JSON.parse(input2)

  const result = merge(object1, object2)
  return JSON.stringify(result, null, useTabs ? '\t' : tabWidth)
}